import { ToursSearch, Util } from 'package-types';
import { SearchResultPayload, SearchResultResponse } from '@interfaces/tours-search-result';

export type ToursSearchSort = 'rating' | 'price_asc';

export const defaultToursSearchSort: ToursSearchSort = 'rating';
export const searchSorts: ToursSearchSort[] = ['rating', 'price_asc'];

export type SearchResponse = Util.Modify<ToursSearch.Actions.SearchResult, { searchId: string }> & SearchResultResponse;
export type GetResultResponse = Util.Modify<ToursSearch.Actions.GetResultResult, { result: SearchResultPayload }> & SearchResultResponse;

export type GetSuggestionsResponse = Util.Modify<ToursSearch.Actions.GetSuggestionsResult, { suggestions: RawSuggestion[] }>;

// Raw types are used to objects obtained from api before correct type conversion (Date, Decimal, etc.)

export type RawSuggestion = Util.Modify<ToursSearch.Suggestion, { price?: string, priceUAH?: string }>;
